/**
 * Represents all sizes
 */
var Size;
(function (Size) {
    Size["extraSmall"] = "extra-small";
    Size["small"] = "small";
    Size["medium"] = "medium";
    Size["large"] = "large";
})(Size || (Size = {}));
/**
 * Represents commonly used sizes
 */
var StandardSize;
(function (StandardSize) {
    StandardSize["small"] = "small";
    StandardSize["medium"] = "medium";
    StandardSize["large"] = "large";
})(StandardSize || (StandardSize = {}));

export { Size, StandardSize };
